/* 🤖 this file was generated by svg-to-ts */
export const matIconCropLandscape: {
  name: 'crop-landscape';
  data: string;
} = {
  name: 'crop-landscape',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"/></svg>`
};
